/**
 * Utility function to open Zendesk chat widget
 * This function works with the global OpenChat function created by chat-script.js
 */
export const openZendeskChat = () => {
  // Check if the global OpenChat function exists (loaded by chat-script.js)
  if (window.OpenChat) {
    window.OpenChat();
  } else if (window.zE) {
    // Fallback: try direct zE call if OpenChat not loaded yet
    try {
      window.zE('webWidget', 'open');
    } catch (error) {
      console.log('Chat is loading. Please try again in a moment.');
    }
  } else {
    console.log('Chat widget is still loading. Please wait a moment and try again.');
  }
};

